// ====================================================================
// ziven-core forum phoneAuthHelpers - (Trello 卡 6a7fc343f990e73904af2c75)
// ====================================================================
//
// 抽公共的 phone auth helpers, 让 PhoneLogin.js (登录) 和
// SignUp.js (注册) 都引用同一份实现.
//
// 抽的 4 个 helper (跟现状 100% 行为一致):
//   - sendSmsCode(modal): POST /api/ziven/core/phone/send-code (60s 倒计时)
//   - startCountdown(modal): 启动 60s 倒计时 timer
//   - startPasswordLockCountdown(modal, seconds): 启动锁定倒计时 timer
//   - clearTimers(modal): 清所有 timer (onremove 用)
//
// 调用方: PhoneLogin.js + SignUp.js (都用这 4 个 helper)
// 设计: 每个 helper 接收 modal instance 作为第一参数, 这样 Stream 引用走 modal.xxx()
//   而不是 import 全局, 避免污染. 跟现状一致 (PhoneLogin.js 现状
//   每个方法内部 this.xxx() 走 modal instance).
//
// 不抽:
//   - phoneLogin / phonePasswordLogin (登录专用, 调 /phone/login*)
//   - phoneRegisterCode / phoneRegisterPassword (注册专用, 调 /phone/register*)
//   登录和注册 endpoints 不同, 错误处理不同 (注册有 409 phone/username 重复, 登录没),
//   不强抽.
// ====================================================================
import app from 'flarum/forum/app';

/**
 * 发送验证码 — POST /api/ziven/core/phone/send-code
 * @param {object} modal - SignUpModal 或 LogInModal 实例 (this)
 * @returns {void}
 */
export function sendSmsCode(modal) {
  const phone = (modal.phoneNumber() || '').trim();
  if (!/^1[3-9]\d{9}$/.test(phone)) {
    app.alerts.show({
      type: 'error'
    }, app.translator.trans('ziven-community-core.forum.login_error_invalid_phone'));
    return;
  }
  modal.phoneSending(true);
  app.request({
    method: 'POST',
    url: app.forum.attribute('apiUrl') + '/ziven/core/phone/send-code',
    body: {
      phone
    },
    errorHandler: err => {
      modal.phoneSending(false);
      const code = err && err.status;
      if (code === 429) {
        app.alerts.show({
          type: 'error'
        }, app.translator.trans('ziven-community-core.forum.login_error_rate_limited'));
      } else if (code === 403) {
        app.alerts.show({
          type: 'error'
        }, app.translator.trans('ziven-community-core.forum.login_error_disabled'));
      } else if (code === 404) {
        // 删 user_not_found 后不再触发, 但保留防御性 (老版本兼容)
        app.alerts.show({
          type: 'error'
        }, app.translator.trans('ziven-community-core.forum.login_error_user_not_found'));
      } else {
        const msg = err && err.alert && err.alert.content || app.translator.trans('ziven-community-core.forum.login_error_send_failed');
        app.alerts.show({
          type: 'error'
        }, msg);
      }
    }
  }).then(response => {
    modal.phoneSending(false);
    if (response && response.success) {
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('ziven-community-core.forum.login_code_sent', {
        phone: response.data.phone
      }));
      startCountdown(modal);
    }
  }).catch(() => {
    modal.phoneSending(false);
  });
}

/**
 * 60s 倒计时 (防止连点)
 * @param {object} modal
 */
export function startCountdown(modal) {
  modal.phoneCountdown(60);
  modal._phoneCountdownTimer = setInterval(() => {
    const n = modal.phoneCountdown() - 1;
    if (n <= 0) {
      modal.phoneCountdown(0);
      clearInterval(modal._phoneCountdownTimer);
    } else {
      modal.phoneCountdown(n);
    }
    m.redraw();
  }, 1000);
}

/**
 * 锁定倒计时 (服务端返 lockRemaining 秒, 前端 1 秒 1 减)
 * @param {object} modal
 * @param {number} seconds
 */
export function startPasswordLockCountdown(modal, seconds) {
  modal.phonePasswordLockCountdown(seconds);
  modal._phonePasswordLockCountdownTimer = setInterval(() => {
    const n = modal.phonePasswordLockCountdown() - 1;
    if (n <= 0) {
      modal.phonePasswordLockCountdown(0);
      clearInterval(modal._phonePasswordLockCountdownTimer);
      modal._phonePasswordLockCountdownTimer = null;
    } else {
      modal.phonePasswordLockCountdown(n);
    }
    m.redraw();
  }, 1000);
}

/**
 * 清所有 timer (onremove 用, 避免内存泄漏)
 * @param {object} modal
 */
export function clearTimers(modal) {
  if (modal._phoneCountdownTimer) {
    clearInterval(modal._phoneCountdownTimer);
    modal._phoneCountdownTimer = null;
  }
  if (modal._phonePasswordLockCountdownTimer) {
    clearInterval(modal._phonePasswordLockCountdownTimer);
    modal._phonePasswordLockCountdownTimer = null;
  }
}
flarum.reg.add('ziiven-ziven-core', 'forum/utils/phoneAuthHelpers', { sendSmsCode: sendSmsCode,startCountdown: startCountdown,startPasswordLockCountdown: startPasswordLockCountdown,clearTimers: clearTimers, });